import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";
import { STORAGE_KEYS } from "@/lib/storage-keys";

/**
 * Wraps protected routes to redirect users who must change their password.
 * Checks localStorage for the `must_change_password` flag set during login.
 */
export function RequirePasswordChange() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) return <Outlet />;

  const mustChange = localStorage.getItem(STORAGE_KEYS.MUST_CHANGE_PASSWORD) === "true";

  if (mustChange) {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
